import isValidConversationCache from '../utils/isValidConversationCache';
import readingPaneStore from 'mini-mail-reading-pane-store/lib/store/Store';
import { action, select } from 'satcheljs/lib/legacy';
import { GET_READING_PANE_DATA_FETCH_DURATION } from 'mini-workflow-tracking/lib/constants/ReadingPaneWorkflowConstants';
import { lazyFirstLoadConversationReadingPane } from 'mini-mail-reading-pane-post-load-conversation';
import { lazyLoadConversation } from 'mini-mail-load-conversation';
import { ObservableMap } from 'mobx';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import type ConversationReadingPaneViewState from 'mini-mail-reading-pane-store/lib/store/schema/ConversationReadingPaneViewState';
import type ItemPartViewState from 'mini-mail-reading-pane-store/lib/store/schema/ItemPartViewState';
import type LoadingState from 'mini-mail-reading-pane-store/lib/store/schema/LoadingState';
import type ReadingPaneStore from 'mini-mail-reading-pane-store/lib/store/schema/ReadingPaneStore';
export interface LoadConversationReadingPaneState {
    readingPaneStore?: ReadingPaneStore;
}

function createInitialConversationState(
    conversationId: string,
    initiallySelectedItemId: string
): ConversationReadingPaneViewState {
    const initialLoadingState: LoadingState = {
        isLoading: true,
        hasLoadFailed: false,
    };
    const initialConversationState: ConversationReadingPaneViewState = {
        conversationId: conversationId,
        initiallySelectedItemId,
        itemPartsMap: new ObservableMap<string, ItemPartViewState>({}),
        loadingState: initialLoadingState,
    };
    return initialConversationState;
}

/**
 * @initiallySelectedItemId is passed in case of search
 */
export default select<LoadConversationReadingPaneState>({
    readingPaneStore: () => readingPaneStore,
})(
    action('loadConversationReadingPane')(function loadConversationReadingPane(
        conversationId: string,
        initiallySelectedItemId: string,
        state?: LoadConversationReadingPaneState
    ): Promise<void> {
        // Update current conversation reading pane state to be initial state.
        state.readingPaneStore.conversationReadingPaneViewState = createInitialConversationState(
            conversationId,
            initiallySelectedItemId
        );
        const hasValidConversationCache = isValidConversationCache(conversationId);

        if (hasValidConversationCache) {
            lazyFirstLoadConversationReadingPane.importAndExecute(conversationId);
            // Signal data load start and data load end to be zero as item is cached
            signalWorkflowEvent(GET_READING_PANE_DATA_FETCH_DURATION, { dls: 0, dle: 0 });

            return Promise.resolve();
        } else {
            return lazyLoadConversation.importAndExecute(conversationId);
        }
    })
);
